module.exports = __webpack_public_path__ + "6781dc6d7ab23c3e23653f493e101f48.MP3";